import React from 'react';
import { IconButton } from '@mui/material';
import GetAppIcon from '@mui/icons-material/GetApp';
import axiosInstance from '../../../../../app/axiosInstance';
import configSiteUrls from '../../../configs/configSiteUrls';

interface DownloadAnexoButtonProps {
  ida: string; // ID do anexo
  fileName: string; // Nome do arquivo a ser salvo
  tipo: string;
}

const DownloadAnexoButton: React.FC<DownloadAnexoButtonProps> = ({ ida, fileName, tipo }) => {
  const endpointUrlPublic = configSiteUrls.SITE_ANEXO_PUBLIC_EP;

  const handleDownloadFileAXIOS = () => {
    axiosInstance({
      url: `${endpointUrlPublic}/download?ida=${ida}&tipo=${tipo}`,
      method: 'GET',
      responseType: 'blob'
    })
      .then(function (response) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName || 'arquivo');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url); // limpa o blob
      })
      .catch(function (error) {
        console.error('Erro ao baixar o arquivo:', error);
      });
  };

  return (
    <IconButton color="secondary" aria-label="download" onClick={handleDownloadFileAXIOS}>
      <GetAppIcon color="primary" />
    </IconButton>
  );
};

export default DownloadAnexoButton;
